import React from "react";
import { Survey } from "./survey-types";
import { useNavigate, useOutletContext } from "react-router-dom";
import SurveyEditor from "./editor/SurveyEditor";
import { storageService } from "../../services/StorageService";

const SurveyEditTab: React.FC = () => {
  const navigate = useNavigate();
  const { survey, updateSurvey } = useOutletContext<{
    survey: Survey | undefined;
    updateSurvey: (survey: Survey) => void;
  }>();

  function onSubmit(survey: any) {
    storageService.saveSurvey(survey);
    updateSurvey(survey);
    navigate(`/surveys/${survey.id}`);
  }

  return <>{survey && <SurveyEditor survey={survey} onSubmit={onSubmit} />}</>;
};

export default SurveyEditTab;
